import React, { useContext, useEffect, useRef, useState } from 'react'

import { SimpleSelectableOption } from '@/components/Shared/SimpleSelectableOption'

import { CollectionContext } from './collection-context'

import './FilterPanel.scss'
import clsx from 'clsx'

type Props = {
  isFiltersMenuOpen: boolean
}

export const FilterPanel: React.FC<Props> = ({ isFiltersMenuOpen }) => {
  const {
    filters,
    collectionLinks,
    isFilterApplied,
    isFilterAvailable,
    handleFilterChange,
  } = useContext(CollectionContext)

  const [filtersBodyMaxHeight, setFiltersBodyMaxHeight] = useState(
    isFiltersMenuOpen ? 'none' : 0,
  )

  const filtersBodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!filtersBodyRef.current) return

    if (isFiltersMenuOpen) {
      setFiltersBodyMaxHeight(filtersBodyRef.current?.scrollHeight)
    } else {
      setFiltersBodyMaxHeight(0)
    }
  })

  return (
    <div
      className={clsx(
        'collection-filter-panel',
        isFiltersMenuOpen && 'collection-filter-panel--open',
      )}
      ref={filtersBodyRef}
      style={{ maxHeight: filtersBodyMaxHeight }}
    >
      {collectionLinks?.length && (
        <div className="collection-filter-panel__group">
          <div className="collection-filter-links">
            {collectionLinks.map((collectionLink) => (
              <a
                className="collection-filter-links__item button button--tertiary"
                key={collectionLink._id}
                href={`/collections/${collectionLink.slug}`}
              >
                {collectionLink.title}
              </a>
            ))}
          </div>
        </div>
      )}
      {filters?.map((filterGroup) => (
        <div className="collection-filter-panel__group" key={filterGroup._id}>
          <div className="type-label">{filterGroup.title}</div>
          <div className="collection-filter-panel__group-items">
            {filterGroup.items.map((filter) => (
              <div
                className="collection-filter-panel__group-item type-body"
                key={filter._id}
              >
                <SimpleSelectableOption
                  id={`${filterGroup._id}-${filter.label}`}
                  name={filterGroup.title}
                  value={filter.label}
                  label={filter.label}
                  checked={isFilterApplied({ filter, filterGroup })}
                  disabled={!isFilterAvailable({ filter, filterGroup })}
                  onClick={() => handleFilterChange({ filter, filterGroup })}
                  type="radio"
                  styling="borderless"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
